import React, { useEffect, useState } from 'react'
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import HttpLinkServices from "../../../services/HttpLinkServices"
import gql from "graphql-tag";
import './styles.css'

import { disableInteraction } from '../ModalFunctions'

import Button from '../../CustomButton/CustomButton'

const TermoCompromissoModal = ({ id, consentiu }) => {

  if (consentiu) return null

  const [isDisabled, setIsDisabled] = useState(true);

  disableInteraction()

  const account_client = new ApolloClient({
    link: HttpLinkServices.account,
    cache: new InMemoryCache(),
  });

  const handleButtonClick = () => {
    account_client.mutate({
      mutation: gql`
        mutation {
          updateTermosCompromisso (id: ${id}, consentiu_compromisso: true) {
            id,
            consentiu_compromisso
          }
        }
      `,
    }).then(() => window.location.reload(true))
  }

  useEffect(() => {
    const textContainer = document.getElementById("textContainer");
    if (
      textContainer &&
      textContainer.scrollHeight === textContainer.clientHeight
    )
    setIsDisabled(false);
  }, []);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (scrollHeight - scrollTop === clientHeight) setIsDisabled(false);
  };

  return (
    <div className='modal-container'>
      <div className='card-container' >
          <div id='textContainer' onScroll={handleScroll}> 
            <h1 className='compromisso-title'>
              TERMO DE COMPROMISSO E RESPONSABILIDADE<br/>
              Acesso e Uso à Plataforma Educacional<br/>
              PORTO SEGURO (“Porto Educ”)
            </h1>

            <p>
              <span className='paragraph-number'>1.</span>
              Estou sendo contemplado, pela PORTO SEGURO, com a possibilidade de participação em cursos e/ou outras oportunidades de recebimento de conteúdo para fins de treinamento, aprimoramento e/ou desenvolvimento pessoal, mediante acesso e uso de uma plataforma educacional (“Porto Educ”) de titularidade da própria PORTO SEGURO.
              <br/><br/>

              <span className='paragraph-number'>1.1</span>
              Para os fins deste termo, PORTO SEGURO significa as empresas integrantes do grupo econômico Porto Seguro.
            </p>

            <p>
              <span className='paragraph-number'>2.</span>
              Declaro ciência que todo e qualquer conteúdo disponibilizado na plataforma educacional à qual terei acesso em virtude da concessão feita pela PORTO SEGURO é legalmente protegido por direitos autorais, notadamente pela Lei n. 9.610, de 19 de fevereiro de 1998 (que atualiza e consolida a legislação sobre direitos autorais), <strong>estando terminantemente vedado o uso desse conteúdo senão para os estritos e exclusivos fins educacionais aos quais o acesso à plataforma é concedido.</strong>
            </p>

            <p>
              <span className='paragraph-number'>3.</span>
              <strong>Declaro, ainda, plena ciência de que é absolutamente vedado que os conteúdos aos quais eu tiver acesso em virtude do uso da plataforma educacional sejam copiados, divulgados, reproduzidos, distribuídos, compartilhados com terceiros, a título oneroso ou gratuito, sob pena de responsabilização cível e criminal, nos termos da legislação vigente, comprometendo-me a me abster de todo e qualquer comportamento que constitua violação desses deveres.</strong>
              <br/><br/>

              <span className='paragraph-number'>3.1</span>
              <strong>Declaro ciência de que, sem prejuízo de outras responsabilidades previstas pela legislação, a violação de direito autoral constitui crime, nos termos do art. 184 do Código Penal.</strong>
            </p>

            <p>
              <span className='paragraph-number'>4.</span>
              O acesso e uso da plataforma educacional acima referida são permitidos pela PORTO SEGURO a seu exclusivo critério e conveniência, estando eu ciente de que, a qualquer momento, a PORTO SEGURO poderá revogar essas permissões, sem qualquer ônus.
            </p>

            <p>
              <span className='paragraph-number'>5.</span>
              A concessão de acesso e uso da plataforma educacional, bem como o conteúdo que será transmitido por meio dela, constituem oportunidades de aprendizado, aprimoramento, conhecimento e desenvolvimento que estão me sendo oferecidos pela PORTO SEGURO, estando eu ciente e de acordo de que os conteúdos que serão compartilhados na plataforma serão definidos a exclusivo critério e conveniência da PORTO SEGURO.
              <br/><br/>

              <span className='paragraph-number'>5.1</span>
              Declaro ciência e concordância que os conteúdos que a PORTO SEGURO compartilhará por meio da plataforma educacional, ainda que voltados à aquisição de conhecimento e desenvolvimento pessoal, não obrigam a PORTO SEGURO a assegurar que os conteúdos serão efetivamente assimilados e/ou que o aprendizado e/ou que o desenvolvimento pessoal esperado seja plenamente atingido. O compromisso da PORTO SEGURO é o de tão somente disponibilizar acesso aos conteúdos, enquanto eu estiver autorizado, pela própria PORTO SEGURO, a ter acesso e uso da plataforma.
            </p>

            <p>
              <span className='paragraph-number'>6.</span>
              <strong>Mediante o aceite eletrônico que ora realizo, declaro plena concordância com todas as disposições do presente Termo. </strong>
            </p>
          </div>
          <Button
            id='termos-btn'
            bsStyle='info'
            fill
            onClick={handleButtonClick}
            disabled={isDisabled}
          >
            Aceitar
          </Button>
        <div/>
      </div>
    </div>
  )
}

export default TermoCompromissoModal



// WEBPACK FOOTER //
// ./src/components/Modal/TermoCompromisso/index.js